export class Utility {
    ProgramsponsorId: string;
    ProgramsponsorDescription: string;
    OfficeId: string;
    LoggedInUserRole:string;
    BBCSUserId:string;
    Source:any;
}